import React, { PureComponent } from 'react';

import classnames from 'classnames';
import { translate } from 'react-i18next';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';

import AssetsFormFilesPreview from 'components/assets/form_sections/AssetsFormFilesPreview';

class AssetsFormFiles extends PureComponent {
  static propTypes = {
    uploaded: PropTypes.array,
    files: PropTypes.array.isRequired,
    handleFileAdd: PropTypes.func.isRequired,
    handleFileRemove: PropTypes.func.isRequired,
    handleFileUploadedRemove: PropTypes.func,
    handleFileChange: PropTypes.func,
    addMsg: PropTypes.func,
    t: PropTypes.func.isRequired,
  };

  state = { active: false };

  accepted = ['.jpeg', '.jpg', '.png', '.xls', '.xlsx', '.doc', '.docx', '.pdf', '.xml', '.csv'];

  limitSize = 1024 * 1024 * 10; // 10 MB
  // limitSize = 1024; // 1 KB

  limiteSizeString = this.limitSize / 1024 / 1024 + 'MB';

  getAcceptedFiles = () => {
    return [...this.accepted.map((ext) => ext.toUpperCase()), ...this.accepted].join(',');
  };

  onDragEnter = () => {
    this.setState({ active: true });
  };
  onDragLeave = () => {
    this.setState({ active: false });
  };

  MAX_WIDTH = 320;
  MAX_HEIGHT = 180;
  // MIME_TYPE = "image/jpeg";
  QUALITY = 0.7;

  onDrop = async (files, rejectedFiles) => {
    // const reader = new FileReader()
    // reader.readAsDataURL(files[0], 0.7)

    console.log('%c ' + rejectedFiles, 'background: #222; color: #bada55');
    if (rejectedFiles.length > 0) {
      this.props.addMsg('error.asset.size_limit_exceded', 'error', 'common.error');
      return
    }
    console.log('%c ' + files[0], 'background: #222; color: #bada55');

    console.log('Name of the file', files[0].name); //*******/
    console.log('Size of the file', files[0].type); //*******/

    await files.forEach((file) => {
      const isImage = file.type.includes('image');
      if (isImage) {
        const img = new Image();
        img.src = file.preview;

        img.onerror = function () {
          URL.revokeObjectURL(this.src);
          // Handle the failure properly
          console.log('Cannot load image');
        };

        img.onload = async () => {
          console.log('%c ' + img.width, 'background: #222; color: #bada55');
          console.log('%c ' + img.height, 'background: #222; color: #bada55');

          URL.revokeObjectURL(this.src);
          // const [newWidth, newHeight] = this.calculateSize(img, this.MAX_WIDTH, this.MAX_HEIGHT);
          const [newWidth, newHeight] = this.calculateSize(
            img,
            img.width * this.QUALITY,
            img.height * this.QUALITY
          );
          const canvas = document.createElement('canvas');
          canvas.width = newWidth;
          canvas.height = newHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, newWidth, newHeight);
          await canvas.toBlob(
            (blob) => {
              // Handle the compressed image. es. upload or save in local state
              let newFilesToUpload = [];
              this.displayInfo('Original file', file);
              const objectURL = URL.createObjectURL(blob);

              console.log('%c ' + objectURL, 'background: #222; color: #bada55');

              this.displayInfo('Compressed file', blob);
              // let newFile = { ...blob, name: file.name, lastModifiedDate: new Date() };
              let newFile = new File([blob], file.name, { lastModified: new Date() });
              newFilesToUpload.push(newFile);
              this.setState({ active: false }, () => this.props.handleFileAdd(newFilesToUpload));
            },
            file.type,
            this.QUALITY
          );
        };
        img.onloadend = (e) => {
          console.log('%c ' + img, 'background: #222; color: #bada55');
          console.log('%c ' + e, 'background: #222; color: #bada55');
        };
      } else {
        this.setState({ active: false }, () => this.props.handleFileAdd([file]));
      }
    });
    // this.setState({ active: false }, () => this.props.handleFileAdd(files));
    // this.setState({ active: false }, () => this.props.handleFileAdd([reader]));
  };

  displayInfo(label, file) {
    const text = `${label} - ${this.readableBytes(file.size)}`;
    console.log('%c ' + text, 'background: #222; color: #bada55');
  }

  readableBytes(bytes) {
    const i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
  }

  calculateSize(img, maxWidth, maxHeight) {
    let width = img.width;
    let height = img.height;

    // calculate the width and height, constraining the proportions
    if (width > height) {
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height);
        height = maxHeight;
      }
    }
    return [width, height];
  }

  render = () => (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{this.props.t('assets.section.files')}</b>
        </h5>
        <br />
      </div>
      <div
        className="col-sm-12 mb-3"
        style={{
          whiteSpace: 'pre-line',
        }}
      >
        <Dropzone
          className={classnames('files-dropzone', {
            active: this.state.active,
          })}
          accept={this.getAcceptedFiles()}
          minSize={0}
          maxSize={this.limitSize}
          onDrop={this.onDrop}
          onDragEnter={this.onDragEnter}
          onDragLeave={this.onDragLeave}
        >
          <p>
            <i className="fa fa-cloud-upload fa-lg" />
            {'  '}
            {this.state.active
              ? this.props.t('common.filesActive')
              : this.props.t('common.filesLimits')(this.limiteSizeString, this.getAcceptedFiles())}
          </p>
        </Dropzone>
      </div>
      <AssetsFormFilesPreview
        uploaded={this.props.uploaded}
        handleUploadedRemove={this.props.handleFileUploadedRemove}
        files={this.props.files}
        handleRemove={this.props.handleFileRemove}
        handleFileChange={this.props.handleFileChange}
      />
    </div>
  );
}

export default translate()(AssetsFormFiles);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormFiles.js